import { GFV } from "../../GFV";

import { FormInfo } from "./FnsFormInfo";
import { PrintInfo } from "./PrintInfo";

export interface ClientDraftInfoResponse {
    gfv: GFV;
    engineVersion: string;
    isIndividual: boolean;
    isForeign: boolean;
    feedbackEnabled: boolean;
    candyTourAvailable: boolean;
    printInfo: PrintInfo;
    regions: number[];
    formInfo: FormInfo;
    hasTemplates: boolean;
    canCheckByPopd: boolean;
    actualGfvInventory: string;
}
